import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from 'i18next';

// Sahifa sarlavhasi va tavsifi (brauzer tabi, Google, ulashish). E'lon sahifalari o'z sarlavhasini o'zi qo'yadi.
const PAGES = [
  [/^\/$/, "Ijarachi — ijara uy, kvartira va xonadosh topish | Toshkent va O'zbekiston",
    "Toshkent va butun O'zbekiston bo'ylab ijaraga kvartira, hovli uy va bo'sh xona topish, mos xonadosh izlash platformasi. Moslik foizi, narx bahosi va xaritada qidirish."],
  [/^\/allrentadvertising/, "Ijaraga uylar va kvartiralar — Ijarachi",
    "Ijaraga kvartira va hovli uylar: narx, tuman, xonalar soni va xarita bo'yicha qidiring. Egasi bilan to'g'ridan-to'g'ri bog'laning."],
  [/^\/allpatneradvertising/, "Xonadosh (sherik) topish — Ijarachi",
    "Bo'sh xonaga xonadosh qidirayotganlar va sherik bilan uy ijaraga oluvchilar e'lonlari. Talabalar va ishlaydiganlar uchun arzon variantlar."],
  [/^\/wanted/, "Uy qidiruvchilar — Ijarachi",
    "Ijarachilar qanday uy kerakligini yozadi: byudjet, tuman, xonalar soni. Mos e'loningizni bir bosishda taklif qiling."],
  [/^\/about/, "Biz haqimizda — Ijarachi",
    "Ijarachi — ijara uy va mos xonadosh topishni osonlashtiradigan platforma."],
  [/^\/login/, "Kirish — Ijarachi", null],
  [/^\/registr/, "Ro'yxatdan o'tish — Ijarachi", null],
  [/^\/forgot-password/, "Parolni tiklash — Ijarachi", null],
  [/^\/profile/, "Kabinet — Ijarachi", null],
  [/^\/admin/, "Admin panel — Ijarachi", null],
];

export function setMeta(name, content) {
  if (!content) return;
  const attr = name.startsWith('og:') ? 'property' : 'name';
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) { el = document.createElement('meta'); el.setAttribute(attr, name); document.head.appendChild(el); }
  el.setAttribute('content', content);
}

/** Sarlavha + tavsif + og/twitter teglarini bitta joyda yangilaydi. */
export function applySeo(title, description) {
  if (title) { document.title = title; setMeta('og:title', title); setMeta('twitter:title', title); }
  if (description) { setMeta('description', description); setMeta('og:description', description); setMeta('twitter:description', description); }
  setMeta('og:url', window.location.origin + window.location.pathname);
  const canon = document.head.querySelector('link[rel="canonical"]');
  if (canon) canon.setAttribute('href', window.location.origin + window.location.pathname);
}

/** App darajasida: yo'l o'zgarganda (va til almashganda) bo'lim sarlavhasini qo'yadi. */
export function useRouteSeo(pathname) {
  const { t } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = (i18n.language || 'uz').slice(0, 2);
    if (/^\/(addinner|patneraddinner|ijara|xonadosh|maslahatlar)(\/|$)/.test(pathname)) return; // e'lon, landing va blog sahifalari o'zi qo'yadi
    const page = PAGES.find(([re]) => re.test(pathname));
    if (!page) return;
    // Bosh sahifa tavsifida domen ham turadi — «myijarachi» brend so'rovi uchun (index.html bilan bir xil)
    const desc = page[2] ? (pathname === '/' ? 'Ijarachi (myijarachi.uz) — ' : '') + t(page[2]) : null;
    applySeo(t(page[1]), desc);
  }, [pathname, t]);
}

/**
 * E'lon sahifasi sarlavhasi va tavsifi — serverdagi (SpaFallbackFilter) bilan bir xil qoida:
 * qisqa sarlavha (~60 belgi): "2 xonali kvartira, Yunusobod — $600/oy | Ijarachi"; tavsif — avval faktlar, keyin egasining matni.
 */
export function adSeo(ad, partner, t) {
  const usd = ad.currency === 'USD' && ad.priceOriginal != null;
  const per = t('/oy');
  const price = usd ? `$${ad.priceOriginal}${per}`
    : ad.price >= 1e6 ? `${String(+(ad.price / 1e6).toFixed(1)).replace('.', ',')} ${t("mln so'm")}${per}`
    : ad.price ? `${Number(ad.price).toLocaleString('ru-RU')} ${t("so'm")}${per}` : t('narxi kelishiladi');
  const tail = ` — ${price} | Ijarachi`;
  const place = ad.district || ad.region || '';
  const kind = partner ? t('Xonadosh kerak')
    : `${ad.roomCount ? t('{{n}} xonali', { n: ad.roomCount }) + ' ' : ''}${ad.accommodationType === 'YARD' ? t('hovli uy') : t('kvartira')}`;
  const kindCap = kind.charAt(0).toUpperCase() + kind.slice(1);
  const own = (ad.title || '').replace(/\s+/g, ' ').trim();
  const title = own && (own + tail).length <= 65 ? own + tail : `${kindCap}${place ? ', ' + place : ''}${tail}`;
  const facts = [[ad.district, ad.region].filter(Boolean).filter((v, i, a) => a.indexOf(v) === i).join(', '),
    ad.roomVolume ? `${ad.roomVolume} m²` : null].filter(Boolean).join(', ');
  const lead = `${partner ? t("Bo'sh xonaga xonadosh qidirilmoqda") : t('Ijaraga') + ' ' + kind}${facts ? ', ' + facts : ''}. ${price}.`;
  const full = `${lead} ${(ad.description || '').replace(/\s+/g, ' ').trim()}`.trim();
  const description = full.length > 160 ? full.slice(0, 157).replace(/\s+\S*$/, '') + '…' : full;
  return { title, description };
}
